import { transformObjectToCamelCase } from '@utilities';

import type {
  AutomatedReport,
  AutomatedReportSortKey,
  AutomatedReportSource,
  AutomatedReportStatus,
} from '../types';

interface GetAutomatedReportsDataOptions {
  order?: 'asc' | 'desc';
  query?: string;
  sortBy?: AutomatedReportSortKey;
  tags?: AutomatedReportStatus[];
}

const getAutomatedReportStatus = (status: number): AutomatedReportStatus => {
  if (status === 1) return 'is_active';
  if (status === 2) return 'is_inactive';
  if (status === 3) return 'is_expired';
  return '';
};

export const getAutomatedReportsData = (
  data: unknown,
  { order = 'desc', query, sortBy, tags = [] }: GetAutomatedReportsDataOptions
): { items: AutomatedReport[] | undefined } => {
  const transformedData = transformObjectToCamelCase(data) as
    AutomatedReportSource[] | null | undefined;
  const searchLowercase = query?.toLowerCase();
  let searchResults = transformedData
    ?.filter(({ name }) => !query || name?.toLowerCase().includes(searchLowercase ?? ''))
    .reverse()
    .map((report) => ({
      ...report,
      status: getAutomatedReportStatus(report.status),
    }));

  if (tags.length) {
    searchResults = searchResults?.filter((item) => tags.includes(item.status));
  }

  if (sortBy) {
    searchResults?.sort((resultA, resultB) => {
      const valueA = resultA[sortBy];
      const valueB = resultB[sortBy];

      if (valueA === null && valueB === null) return 0;
      if (valueA === null) return -1;
      if (valueB === null) return 1;
      return valueA > valueB ? -1 : 1;
    });

    if (order === 'asc') {
      searchResults?.reverse();
    }
  }

  return {
    items: searchResults,
  };
};
